module.exports = require("./teo.js");